// import React from "react";
// import {
//   Play,
//   Building2,
//   ShieldCheck,
// } from "lucide-react";

// import heroImg from "../../../Images/hero-villa.jpg";
// import cityImg from "../../../Images/city-skyline.jpg";
// import interiorImg from "../../../Images/apartment-interior.jpg";
// import towerImg from "../../../Images/property-tower.jpg";





// export function WinnersAboutBlue() {
//   return (
//     <section className="ws-about_blue">
//       <div className="ws-about-glow_blue" />
//       <div className="ws-about-inner_blue">
//         <div className="ws-about-top_blue">
//           <div className="ws-about-text_blue">
//             <span className="ws-section-eyebrow_blue">About Winners</span>
//             <h2 className="ws-section-heading_blue">
//               Smarter real estate experiences — premium living, trusted investments.
//             </h2>
//             <p>
//               Winners is redefining modern property discovery through curated projects,
//               transparent investment opportunities, and futuristic community experiences across
//               India's top cities.
//             </p>
//             <div className="ws-about-btns_blue">
//               <button className="ws-about-btn_blue solid">Explore more</button>
//               <button className="ws-about-btn_blue outline">View properties</button>
//             </div>
//           </div>

//           <div className="ws-about-visual_blue">
//             <img src={heroImg} alt="Featured living experience" loading="lazy" width={900} height={1100} />
//             <div className="ws-about-play_blue"><Play size={28} fill="currentColor" /></div>
//             <div className="ws-about-vcontent_blue">
//               <span>Featured experience</span>
//               <h4>Luxury spaces crafted for future living</h4>
//             </div>
//           </div>
//         </div>

//         <div className="ws-about-bottom_blue">
//           <div className="ws-about-side-img_blue">
//             <img src={interiorImg} alt="Premium interior" loading="lazy" width={800} height={1000} />
//             <div className="ws-about-float_blue">
//               <h3>20+</h3>
//               <p>Premium cities</p>
//             </div>
//           </div>

//           <div className="ws-about-cards_blue">
//             <div className="ws-about-feature_blue">
//               <div className="ws-about-feature-ic_blue"><Building2 size={22} /></div>
//               <h3>Smart urban communities</h3>
//               <p>We design premium residential ecosystems focused on comfort, accessibility and
//                 strong long-term value.</p>
//             </div>
//             <div className="ws-about-feature_blue">
//               <div className="ws-about-feature-ic_blue"><ShieldCheck size={22} /></div>
//               <h3>Verified, transparent listings</h3>
//               <p>Every property is vetted, with full ownership trails and clear pricing — no
//                 surprises, ever.</p>
//             </div>
//             <div className="ws-about-stats_blue">
//               <div className="ws-about-stat_blue"><h3>1L+</h3><p>Verified listings</p></div>
//               <div className="ws-about-stat_blue"><h3>1600+</h3><p>Localities</p></div>
//               <div className="ws-about-stat_blue"><h3>25Cr+</h3><p>Property value</p></div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }


// import React, { useRef, useLayoutEffect } from "react";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";


// import {
//   Play,
//   Building2,
//   ShieldCheck,
// } from "lucide-react";

// import heroImg from "../../../Images/hero-villa.jpg";
// import cityImg from "../../../Images/city-skyline.jpg";
// import interiorImg from "../../../Images/apartment-interior.jpg";
// import towerImg from "../../../Images/property-tower.jpg";

// gsap.registerPlugin(ScrollTrigger);

// export function WinnersAboutBlue() {

// const sectionRef = useRef(null);

// useLayoutEffect(() => {
//   const ctx = gsap.context(() => {

//     gsap.from(".ws-section-eyebrow_blue", {
//       y: 40,
//       opacity: 0,
//       duration: 0.8,
//       scrollTrigger: {
//         trigger: ".ws-about_blue",
//         start: "top 80%",
//         toggleActions: "play reverse play reverse",
//       },
//     });

//     gsap.from(".ws-section-heading_blue", {
//       y: 60,
//       opacity: 0,
//       duration: 1,
//       scrollTrigger: {
//         trigger: ".ws-about_blue",
//         start: "top 80%",
//         toggleActions: "play reverse play reverse",
//       },
//     });

//     gsap.from(".ws-about-text_blue p", {
//       y: 40,
//       opacity: 0,
//       duration: 0.8,
//       scrollTrigger: {
//         trigger: ".ws-about-text_blue",
//         start: "top 85%",
//         toggleActions: "play reverse play reverse",
//       },
//     });

//     gsap.from(".ws-about-btns_blue", {
//       y: 30,
//       opacity: 0,
//       duration: 0.8,
//       scrollTrigger: {
//         trigger: ".ws-about-btns_blue",
//         start: "top 90%",
//         toggleActions: "play reverse play reverse",
//       },
//     });

//     gsap.from(".ws-about-visual_blue", {
//       x: 100,
//       opacity: 0,
//       scale: 0.9,
//       duration: 1,
//       ease: "power3.out",
//       scrollTrigger: {
//         trigger: ".ws-about-visual_blue",
//         start: "top 85%",
//         toggleActions: "play reverse play reverse",
//       },
//     });

//     gsap.from(".ws-about-side-img_blue", {
//       x: -100,
//       opacity: 0,
//       duration: 1,
//       ease: "power3.out",
//       scrollTrigger: {
//         trigger: ".ws-about-side-img_blue",
//         start: "top 85%",
//         toggleActions: "play reverse play reverse",
//       },
//     });

// gsap.fromTo(
//   ".ws-about-feature_blue",
//   {
//     y: 80,
//     opacity: 0,
//   },
//   {
//     y: 0,
//     opacity: 1,
//     duration: 1,
//     stagger: 0.2,
//     ease: "power3.out",
//     scrollTrigger: {
//       trigger: ".ws-about-bottom_blue",
//       start: "top 80%",
//       end: "bottom 20%",
//       toggleActions: "play reverse play reverse",
//     },
//   }
// );

//     gsap.from(".ws-about-stat_blue", {
//       y: 50,
//       opacity: 0,
//       duration: 0.8,
//       stagger: 0.15,
//       ease: "power3.out",
//       scrollTrigger: {
//         trigger: ".ws-about-stats_blue",
//         start: "top 90%",
//         toggleActions: "restart none restart none",
//       },
//     });

//     gsap.to(".ws-about-float_blue", {
//       y: -12,
//       duration: 2,
//       repeat: -1,
//       yoyo: true,
//       ease: "sine.inOut",
//     });

//     gsap.to(".ws-about-play_blue", {
//       scale: 1.12,
//       duration: 1.4,
//       repeat: -1,
//       yoyo: true,
//       ease: "power1.inOut",
//     });

//   }, sectionRef);

//    setTimeout(() => {
//   ScrollTrigger.refresh();
// }, 100);

//   return () => ctx.revert();
// }, []);
//   return (
//     <section className="ws-about_blue" ref={sectionRef}>
//       <div className="ws-about-glow_blue" />
//       <div className="ws-about-inner_blue">
//         <div className="ws-about-top_blue">
//           <div className="ws-about-text_blue">
//             <span className="ws-section-eyebrow_blue">About Winners</span>
//             <h2 className="ws-section-heading_blue">
//               Smarter real estate experiences — premium living, trusted investments.
//             </h2>
//             <p>
//               Winners is redefining modern property discovery through curated projects,
//               transparent investment opportunities, and futuristic community experiences across
//               India's top cities.
//             </p>
//             <div className="ws-about-btns_blue">
//               <button className="ws-about-btn_blue solid">Explore more</button>
//               <button className="ws-about-btn_blue outline">View properties</button>
//             </div>
//           </div>

//           <div className="ws-about-visual_blue">
//             <img src={heroImg} alt="Featured living experience" loading="lazy" width={900} height={1100} />
//             <div className="ws-about-play_blue"><Play size={28} fill="currentColor" /></div>
//             <div className="ws-about-vcontent_blue">
//               <span>Featured experience</span>
//               <h4>Luxury spaces crafted for future living</h4>
//             </div>
//           </div>
//         </div>

//         <div className="ws-about-bottom_blue">
//           <div className="ws-about-side-img_blue">
//             <img src={interiorImg} alt="Premium interior" loading="lazy" width={800} height={1000} />
//             <div className="ws-about-float_blue">
//               <h3>20+</h3>
//               <p>Premium cities</p>
//             </div>
//           </div>

//           <div className="ws-about-cards_blue">
//             <div className="ws-about-feature_blue">
//               <div className="ws-about-feature-ic_blue"><Building2 size={22} /></div>
//               <h3>Smart urban communities</h3>
//               <p>We design premium residential ecosystems focused on comfort, accessibility and
//                 strong long-term value.</p>
//             </div>
//             <div className="ws-about-feature_blue">
//               <div className="ws-about-feature-ic_blue"><ShieldCheck size={22} /></div>
//               <h3>Verified, transparent listings</h3>
//               <p>Every property is vetted, with full ownership trails and clear pricing — no
//                 surprises, ever.</p>
//             </div>
//             <div className="ws-about-stats_blue">
//               <div className="ws-about-stat_blue"><h3>1L+</h3><p>Verified listings</p></div>
//               <div className="ws-about-stat_blue"><h3>1600+</h3><p>Localities</p></div>
//               <div className="ws-about-stat_blue"><h3>25Cr+</h3><p>Property value</p></div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import {
  Play,
  Building2,
  ShieldCheck,
} from "lucide-react";

import heroImg from "../../../Images/hero-villa.jpg";
import interiorImg from "../../../Images/apartment-interior.jpg";

export function WinnersAboutBlue() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false,
      mirror: true,
    });
  }, []);

  return (
    <section className="ws-about_blue">
      <div className="ws-about-glow_blue" />

      <div className="ws-about-inner_blue">
        <div className="ws-about-top_blue">
          <div className="ws-about-text_blue">
            <span
              className="ws-section-eyebrow_blue"
              data-aos="fade-up"
            >
              About Winners
            </span>

            <h2
              className="ws-section-heading_blue"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              Smarter real estate experiences — premium living,
              trusted investments.
            </h2>

            <p
              data-aos="fade-up"
              data-aos-delay="250"
            >
              Winners is redefining modern property discovery through
              curated projects, transparent investment opportunities,
              and futuristic community experiences across India's top
              cities.
            </p>

            <div
              className="ws-about-btns_blue"
              data-aos="fade-up"
              data-aos-delay="350"
            >
              <button className="ws-about-btn_blue solid">
                Explore more
              </button>

              <button className="ws-about-btn_blue outline">
                View properties
              </button>
            </div>
          </div>

          <div
            className="ws-about-visual_blue"
            data-aos="fade-left"
          >
            <img
              src={heroImg}
              alt="Featured living experience"
              loading="lazy"
              width={900}
              height={1100}
            />

            <div className="ws-about-play_blue">
              <Play size={28} fill="currentColor" />
            </div>

            <div className="ws-about-vcontent_blue">
              <span>Featured experience</span>

              <h4>
                Luxury spaces crafted for future living
              </h4>
            </div>
          </div>
        </div>

        <div className="ws-about-bottom_blue">
          <div
            className="ws-about-side-img_blue"
            data-aos="fade-right"
          >
            <img
              src={interiorImg}
              alt="Premium interior"
              loading="lazy"
              width={800}
              height={1000}
            />

            <div className="ws-about-float_blue">
              <h3>20+</h3>
              <p>Premium cities</p>
            </div>
          </div>

          <div className="ws-about-cards_blue">
            <div
              className="ws-about-feature_blue"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="ws-about-feature-ic_blue">
                <Building2 size={22} />
              </div>

              <h3>Smart urban communities</h3>

              <p>
                We design premium residential ecosystems
                focused on comfort, accessibility and strong
                long-term value.
              </p>
            </div>

            <div
              className="ws-about-feature_blue"
              data-aos="fade-up"
              data-aos-delay="250"
            >
              <div className="ws-about-feature-ic_blue">
                <ShieldCheck size={22} />
              </div>

              <h3>Verified, transparent listings</h3>

              <p>
                Every property is vetted, with full ownership
                trails and clear pricing — no surprises,
                ever.
              </p>
            </div>

            <div
              className="ws-about-stats_blue"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="ws-about-stat_blue">
                <h3>1L+</h3>
                <p>Verified listings</p>
              </div>

              <div className="ws-about-stat_blue">
                <h3>1600+</h3>
                <p>Localities</p>
              </div>

              <div className="ws-about-stat_blue">
                <h3>25Cr+</h3>
                <p>Property value</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}